export default {
  NONE: 0,
  BASE: 1,
  BRONZE: 2,
  SILVERN: 3,
  GOLDEN: 4,
  DIAMOND: 5,
}